import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import { getMenuItems } from '../MenuItems';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const { userInfo } = useSelector((state) => state.auth);
    const { selected } = useSelector((state) => state.management.organization);
    const [menuItems, setMenuItems] = useState({ items: [] });

    useEffect(() => {
        const temp = async () => {
            if (!userInfo.admin_permissions || !userInfo.group_permissions) {
                return;
            }
            const isManaging = !!selected?.orgid;
            const menu = await getMenuItems(userInfo.admin_permissions, userInfo.group_permissions, isManaging);
            setMenuItems(menu);
        };
        temp();
    }, [userInfo.admin_permissions, userInfo.group_permissions, selected]);

    const navItems = menuItems?.items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
